import type { RestartStatus } from '@/features/controller/restart/contexts/ControllerRestartContext'
import { useControllerRestartContext } from '@/features/controller/restart/contexts/ControllerRestartContext'

interface UseControllerRestartStateReturn {
  restartStatus: RestartStatus
  setRestartInProgress: () => void
  setRestartSuccess: () => void
  setRestartError: () => void
  clearRestartStatus: () => void
}

export type { RestartStatus }

export function useControllerRestartState(controllerId: string): UseControllerRestartStateReturn {
  const { restartStatuses, setRestartInProgress, setRestartSuccess, setRestartError, clearRestartStatus } =
    useControllerRestartContext()

  return {
    restartStatus: restartStatuses[controllerId] ?? null,
    setRestartInProgress: () => setRestartInProgress(controllerId),
    setRestartSuccess: () => setRestartSuccess(controllerId),
    setRestartError: () => setRestartError(controllerId),
    clearRestartStatus: () => clearRestartStatus(controllerId),
  }
}
